module.exports = __webpack_public_path__ + "static/og-a05e59541200e0e4aa1b9b2295c00868.png";